var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Facebook2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.265,
    height: 66.264,
    viewBox: "0 0 66.265 66.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M410.26,162.058H399.027l-5.126-1.692-5.084,1.692H377.541a16.772,16.772,0,0,1-16.773-16.771V112.568A16.773,16.773,0,0,1,377.541,95.8H410.26a16.773,16.773,0,0,1,16.773,16.773v32.719A16.772,16.772,0,0,1,410.26,162.058Z",
    transform: "translate(-360.768 -95.795)",
    fill: "#337fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M379.805,115.706v7.212h-8.31v9.46h8.31v23.67h10.227v-23.67h7.627l1.451-9.46h-9.078v-6.14c0-2.587,1.268-5.111,5.334-5.111h4.128v-8.053a50.339,50.339,0,0,0-7.327-.639C384.691,102.973,379.805,107.5,379.805,115.706Z",
    transform: "translate(-351.786 -89.785)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook2);
export default __webpack_public_path__ + "static/media/facebook2.72c8e29da34430089e8b92d1126f0cac.svg";
export { ForwardRef as ReactComponent };